import 'bootstrap-daterangepicker/daterangepicker.css';
import { orderBy } from 'lodash';
import classnames from 'classnames';
import { endOfDay, format, startOfDay } from 'date-fns';
import moment from 'moment';
import Pagination from 'rc-pagination';
import React, { Component } from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import {
  Button,
  ButtonGroup,
  Col,
  Container,
  Input,
  InputGroup,
  InputGroupAddon,
  Row,
  TabContent,
  TabPane,
} from 'reactstrap';
import * as CompanyActions from '../actions/Companies';
import * as FaxActions from '../actions/Fax';
import { getCompanyNumbers } from '../actions/Numbers';
import Breadcrumbs from '../components/Breadcrumb';
import CompanyAutocomplete from '../components/CompanyAutocomplete';
import DeleteFaxModal from '../components/DeleteFaxModal';
import FaxesReportTab from '../components/FaxesReportTab';
import FaxList from '../components/FaxList';
import IncomingFaxList from '../components/IncomingFaxList';
import SendFaxModal from '../components/SendFaxModal';
import SetLimitEntries from '../components/SetLimitEntries';
import WithUserData from '../HOC/withUserData';
import Calendar from '../Res/Icon/Calendar.png';
import filterIcon from '../Res/Icon/filter.png';
import './fax.css';
import { ENG_LOCALE } from '../lib/constants';

class Fax extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // date: [startOfDay(new Date()), endOfDay(new Date())],
      date: [endOfDay(new Date()), moment().subtract(6, 'days')._d],
      selectedUser: '',
      selectedCompany:
        props.user.role === 'admin' || props.user.role === 'enterpriseAdmin'
          ? props.user.company._id
          : '',
      defaultPage: '',
      selectedNumberType: '',
      selectedNumber: '',
      number: '',
      selectedFilter:
        props.user.role === 'superAdmin' ||
          props.user.role === 'supportEngineer' ||
          props.user.role === 'companyGroupAdmin' ||
          props.user.role === 'companyGroupManager'
          ? 'By Company'
          : 'By Destination Number',
      sort: {
        name: '',
        order: '',
      },
    };

    if (
      props.user.role === 'superAdmin' ||
      props.user.role === 'supportEngineer' ||
      props.user.role === 'companyGroupAdmin' ||
      props.user.role === 'companyGroupManager'
    ) {
      this.incomingFaxOptions = ['By Company', 'By Sender Number', 'By Receiver Number'];
      this.outgoingFaxOptions = ['By Company', 'By Destination Number', 'By Caller id'];
    } else {
      this.incomingFaxOptions = ['By Sender Number', 'By Receiver Number'];
      this.outgoingFaxOptions = ['By Destination Number', 'By Caller id'];
    }

    this.token = localStorage.getItem('jwtToken') || null;
    this.onDelete = this.onDelete.bind(this);
    this.onSendFax = this.onSendFax.bind(this);
    this.onDownloadIncomingFax = this.onDownloadIncomingFax.bind(this);
    this.onDownloadOutgoingFax = this.onDownloadOutgoingFax.bind(this);

    this.ranges = {
      Today: [moment(), moment()],
      Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
      'Last 7 Days': [moment().subtract(6, 'days'), moment()],
      'Last 30 Days': [moment().subtract(29, 'days'), moment()],
      'This Month': [moment().startOf('month'), moment().endOf('month')],
      'Last Month': [
        moment()
          .subtract(1, 'month')
          .startOf('month'),
        moment()
          .subtract(1, 'month')
          .endOf('month'),
      ],
    };
  }

  componentWillMount() {
    if (
      this.props.user.role === 'superAdmin' ||
      this.props.user.role === 'supportEngineer' ||
      this.props.user.role === 'companyGroupAdmin' ||
      this.props.user.role === 'companyGroupManager'
    ) {
      this.props.getCompanies(this.token, undefined, 'yes');
      this.props.getFaxes(localStorage.getItem('jwtToken'));
      this.props.getFaxesSummary(this.token);
      this.props.getFaxesFailureSummary(this.token);
    } else if (this.props.user.role === 'admin' || this.props.user.role === 'enterpriseAdmin') {
      this.companyID = this.props.user.company._id;
      // this.props.getFaxesSummary(this.token);
      // this.props.getFaxesFailureSummary(this.token);
      this.setState({ selectedCompany: this.props.user.company._id });
      this.props.getCompanyNumbers(this.token, this.props.user.company._id, true, 'none');
      this.props.getOutgoingFaxesFilter(
        this.token,
        this.props.user.company._id,
        undefined,
        undefined,
        true,
      );
      this.props.getOutgoingFaxesFilter(
        this.token,
        this.props.user.company._id,
        undefined,
        undefined,
        false,
      );
      this.props.getIncomingFaxesFilter(this.token, this.props.user.company._id);
      this.props.getFaxesSummaryByCompany(this.token, this.props.user.company._id, this.state.date);
      this.props.getFaxesFailureSummaryByCompany(
        this.token,
        this.props.user.company._id,
        this.state.date,
      );
    } else {
      this.setState({ selectedUser: this.props.user._id });
      this.props.getOutgoingFaxesByUser(this.token, this.props.user._id, '', this.state.date, true);
      this.props.getOutgoingFaxesByUser(
        this.token,
        this.props.user._id,
        '',
        this.state.date,
        false,
      );
      this.props.getIncomingFaxesByUser(this.token, this.props.user._id, '', this.state.date);
      this.props.getFaxesSummaryByUser(this.token, this.props.user._id, this.state.date);
      this.props.getFaxesFailureSummaryByUser(this.token, this.props.user._id, this.state.date);
    }
  }

  async onDownloadIncomingFax(id) {
    const userID = this.props.user._id;
    await this.props.downloadIncomingFax(this.token, id, userID);
  }

  async onDownloadOutgoingFax(id) {
    const userID = this.props.user._id;
    await this.props.downloadOutgoingFax(this.token, id, userID);
  }

  async onDelete() {
    let res;
    if (this.props.activeFaxTab === 'outgoing') {
      res = await this.props.deleteOutgoingFax(this.token, this.props.deleteFaxID);
      if (res) {
        this.handleChangePagination(this.state.defaultPage);
      }
    } else if (this.props.activeFaxTab === 'incoming') {
      res = await this.props.deleteIncomingFax(this.token, this.props.deleteFaxID);
      if (res) {
        this.handleChangePagination(this.state.defaultPage);
      }
    }
  }

  async onSendFax(fax) {
    // console.log('fax is ', fax)
    // this.props.sendFax(fax);
  }

  handleChangePagination = async numPage => {
    const { selectedCompany, selectedUser, selectedFilter, number } = this.state;
    const {
      faxes,
      getOutgoingFaxes,
      getIncomingFaxes,
      activeFaxTab,
      getOutgoingFaxesFilter,
      getIncomingFaxesFilter,
      getOutgoingFaxesByUser,
      getIncomingFaxesByUser,
      outgoingfaxFilterByNumber,
      incomingfaxFilterByNumber,
    } = this.props;
    this.setState({ defaultPage: numPage });

    if (selectedFilter !== 'By Company' && number.length !== 0) {
      if (activeFaxTab === 'outgoing') {
        if (selectedFilter === 'By Destination Number') {
          await outgoingfaxFilterByNumber(
            this.token,
            'dest',
            number,
            this.state.date,
            {
              page: numPage,
              limit: this.limit || faxes.outgoingFaxes.limit,
            },
            false,
          );
        } else {
          await outgoingfaxFilterByNumber(
            this.token,
            'cid',
            number,
            this.state.date,
            {
              page: numPage,
              limit: this.limit || faxes.outgoingFaxes.limit,
            },
            false,
          );
        }
      } else if (activeFaxTab === 'relay') {
        if (selectedFilter === 'By Destination Number') {
          await outgoingfaxFilterByNumber(
            this.token,
            'dest',
            number,
            this.state.date,
            {
              page: numPage,
              limit: this.limit || faxes.outgoingFaxes.limit,
            },
            true,
          );
        } else {
          await outgoingfaxFilterByNumber(
            this.token,
            'cid',
            number,
            this.state.date,
            {
              page: numPage,
              limit: this.limit || faxes.outgoingFaxes.limit,
            },
            true,
          );
        }
      } else {
        if (this.state.selectedFilter === 'By Sender Number') {
          await incomingfaxFilterByNumber(this.token, 'sender', number, this.state.date, {
            page: numPage,
            limit: this.limit || faxes.outgoingFaxes.limit,
          });
        } else {
          await incomingfaxFilterByNumber(this.token, 'receiver', number, this.state.date, {
            page: numPage,
            limit: this.limit || faxes.outgoingFaxes.limit,
          });
        }
      }
    } else if (selectedCompany === '' && selectedUser === '') {
      if (activeFaxTab === 'outgoing') {
        await getOutgoingFaxes(
          this.token,
          { page: numPage, limit: this.limit || faxes.outgoingFaxes.limit },
          this.state.date,
          false,
        );
      } else if (activeFaxTab === 'relay') {
        await getOutgoingFaxes(
          this.token,
          { page: numPage, limit: this.limit || faxes.outgoingFaxes.limit },
          this.state.date,
          true,
        );
      } else {
        await getIncomingFaxes(
          this.token,
          { page: numPage, limit: this.limit || faxes.incomingFaxes.limit },
          this.state.date,
        );
      }
    } else {
      if (selectedUser !== '') {
        if (activeFaxTab === 'outgoing') {
          await getOutgoingFaxesByUser(
            this.token,
            selectedUser,
            {
              page: numPage,
              limit: this.limit || faxes.outgoingFaxes.limit,
            },
            this.state.date,
            false,
          );
        }
        if (activeFaxTab === 'relay') {
          await getOutgoingFaxesByUser(
            this.token,
            selectedUser,
            {
              page: numPage,
              limit: this.limit || faxes.outgoingFaxes.limit,
            },
            this.state.date,
            true,
          );
        } else {
          await getIncomingFaxesByUser(
            this.token,
            selectedUser,
            {
              page: numPage,
              limit: this.limit || faxes.outgoingFaxes.limit,
            },
            this.state.date,
          );
        }
      } else if (selectedCompany !== '') {
        if (activeFaxTab === 'outgoing') {
          await getOutgoingFaxesFilter(
            this.token,
            selectedCompany,
            {
              page: numPage,
              limit: this.limit || faxes.outgoingFaxes.limit,
            },
            this.state.date,
            false,
          );
        }
        if (activeFaxTab === 'relay') {
          await getOutgoingFaxesFilter(
            this.token,
            selectedCompany,
            {
              page: numPage,
              limit: this.limit || faxes.outgoingFaxes.limit,
            },
            this.state.date,
            true,
          );
        } else {
          await getIncomingFaxesFilter(
            this.token,
            selectedCompany,
            {
              page: numPage,
              limit: this.limit || faxes.outgoingFaxes.limit,
            },
            this.state.date,
          );
        }
      }
    }
  };

  handleSetLimit = async limit => {
    const { selectedCompany, selectedUser, defaultPage, selectedFilter, number } = this.state;
    const {
      getOutgoingFaxes,
      getIncomingFaxes,
      activeFaxTab,
      getOutgoingFaxesFilter,
      getIncomingFaxesFilter,
      getOutgoingFaxesByUser,
      getIncomingFaxesByUser,
      outgoingfaxFilterByNumber,
      incomingfaxFilterByNumber,
    } = this.props;

    this.limit = limit;

    if (selectedFilter !== 'By Company') {
      if (activeFaxTab === 'outgoing') {
        if (selectedFilter === 'By Destination Number') {
          await outgoingfaxFilterByNumber(
            this.token,
            'dest',
            number,
            this.state.date,
            {
              page: 1,
              limit: +limit,
            },
            false,
          );
        } else {
          await outgoingfaxFilterByNumber(
            this.token,
            'cid',
            number,
            this.state.date,
            {
              page: 1,
              limit: +limit,
            },
            false,
          );
        }
      } else if (activeFaxTab === 'relay') {
        if (selectedFilter === 'By Destination Number') {
          await outgoingfaxFilterByNumber(
            this.token,
            'dest',
            number,
            this.state.date,
            {
              page: 1,
              limit: +limit,
            },
            true,
          );
        } else {
          await outgoingfaxFilterByNumber(
            this.token,
            'cid',
            number,
            this.state.date,
            {
              page: 1,
              limit: +limit,
            },
            true,
          );
        }
      } else {
        if ((this.state.selectedFilter = 'By Sender Number')) {
          await incomingfaxFilterByNumber(this.token, 'sender', number, this.state.date, {
            page: 1,
            limit: +limit,
          });
        } else {
          await incomingfaxFilterByNumber(this.token, 'receiver', number, this.state.date, {
            page: 1,
            limit: +limit,
          });
        }
      }
    } else if (selectedCompany === '' && selectedUser === '') {
      let relay = activeFaxTab === 'relay';
      activeFaxTab === 'outgoing' || activeFaxTab === 'relay'
        ? await getOutgoingFaxes(this.token, { page: 1, limit: +limit }, this.state.date, relay)
        : await getIncomingFaxes(this.token, { page: 1, limit: +limit }, this.state.date);
    } else {
      if (selectedUser !== '') {
        if (activeFaxTab === 'outgoing') {
          await getOutgoingFaxesByUser(
            this.token,
            selectedUser,
            {
              page: 1,
              limit: +limit,
            },
            this.state.date,
            false,
          );
        }
        if (activeFaxTab === 'relay') {
          await getOutgoingFaxesByUser(
            this.token,
            selectedUser,
            {
              page: 1,
              limit: +limit,
            },
            this.state.date,
            true,
          );
        } else {
          await getIncomingFaxesByUser(
            this.token,
            selectedUser,
            {
              page: 1,
              limit: +limit,
            },
            this.state.date,
          );
        }
      } else if (selectedCompany !== '') {
        if (activeFaxTab === 'outgoing') {
          await getOutgoingFaxesFilter(
            this.token,
            selectedCompany,
            {
              page: 1,
              limit: +limit,
            },
            this.state.date,
            false,
          );
        }
        if (activeFaxTab === 'relay') {
          await getOutgoingFaxesFilter(
            this.token,
            selectedCompany,
            {
              page: 1,
              limit: +limit,
            },
            this.state.date,
            true,
          );
        } else {
          await getIncomingFaxesFilter(
            this.token,
            selectedCompany,
            {
              page: 1,
              limit: +limit,
            },
            this.state.date,
          );
        }
      }
    }
  };

  handeleClick = e => {
    const el = document.querySelector('.daterangepicker');
    el.classList.toggle('show-dp');
  };

  onApply = (e, piker) => {
    const {
      getOutgoingFaxes,
      getIncomingFaxes,
      getFaxesSummary,
      getFaxesFailureSummary,
      getFaxesSummaryByUser,
      getFaxesFailureSummaryByUser,
      getFaxesSummaryByCompany,
      getFaxesFailureSummaryByCompany,
      getOutgoingFaxesFilter,
      getIncomingFaxesFilter,
      getIncomingFaxesByUser,
      getOutgoingFaxesByUser,
      outgoingfaxFilterByNumber,
      incomingfaxFilterByNumber,
      user,
      activeFaxTab,
    } = this.props;
    const { selectedUser, selectedCompany, selectedFilter, number } = this.state;
    const dataEnd = piker.endDate._d;
    const dataStart = piker.startDate._d;

    this.setState({ date: [dataEnd, dataStart] }, async () => {
      if (selectedFilter !== 'By Company') {
        if (activeFaxTab === 'outgoing') {
          if (selectedFilter === 'By Destination Number') {
            await outgoingfaxFilterByNumber(this.token, 'dest', number, this.state.date, '', false);
          } else {
            await outgoingfaxFilterByNumber(this.token, 'cid', number, this.state.date, '', false);
          }
        } else if (activeFaxTab === 'relay') {
          if (selectedFilter === 'By Destination Number') {
            await outgoingfaxFilterByNumber(this.token, 'dest', number, this.state.date, '', true);
          } else {
            await outgoingfaxFilterByNumber(this.token, 'cid', number, this.state.date, '', true);
          }
        } else {
          if (this.state.selectedFilter === 'By Sender Number') {
            await incomingfaxFilterByNumber(this.token, 'sender', number, this.state.date, '');
          } else {
            await incomingfaxFilterByNumber(this.token, 'receiver', number, this.state.date, '');
          }
        }
      } else if (
        (user.role === 'superAdmin' ||
          user.role === 'supportEngineer' ||
          user.role === 'companyGroupAdmin' ||
          user.role === 'companyGroupManager') &&
        selectedUser === '' &&
        selectedCompany === ''
      ) {
        await getOutgoingFaxes(this.token, {}, this.state.date, true);
        await getOutgoingFaxes(this.token, {}, this.state.date, false);
        await getIncomingFaxes(this.token, {}, this.state.date);
        await getFaxesSummary(this.token, this.state.date);
        await getFaxesFailureSummary(this.token, this.state.date);
      }
      if (selectedUser !== '') {
        await getOutgoingFaxesByUser(this.token, selectedUser, '', this.state.date, true);
        await getOutgoingFaxesByUser(this.token, selectedUser, '', this.state.date, false);
        await getIncomingFaxesByUser(this.token, selectedUser, '', this.state.date);
        await getFaxesSummaryByUser(this.token, selectedUser, this.state.date);
        await getFaxesFailureSummaryByUser(this.token, selectedUser, this.state.date);
      } else if (selectedCompany !== '') {
        await getOutgoingFaxesFilter(this.token, selectedCompany, '', this.state.date, true);
        await getOutgoingFaxesFilter(this.token, selectedCompany, '', this.state.date, false);
        await getIncomingFaxesFilter(this.token, selectedCompany, '', this.state.date);
        await getFaxesSummaryByCompany(this.token, selectedCompany, this.state.date);
        await getFaxesFailureSummaryByCompany(this.token, selectedCompany, this.state.date);
      }
    });
  };

  companySearchFilter = async ({ name, value, suggestion }) => {
    const {
      getOutgoingFaxesFilter,
      getIncomingFaxesFilter,
      getCompanyNumbers,
      getFaxesSummaryByCompany,
      getFaxesFailureSummaryByCompany,
      getOutgoingFaxes,
      getIncomingFaxes,
      activeFaxTab,
      user,
    } = this.props;
    this.setState({
      selectedNumber: '',
    });
    if (suggestion !== null) {
      this.setState({ selectedCompany: suggestion._id });
      await getCompanyNumbers(this.token, suggestion._id, true, global.deleteMode ? 'none' : 'all');
      await getOutgoingFaxesFilter(this.token, suggestion._id, '', this.state.date, true);
      await getOutgoingFaxesFilter(this.token, suggestion._id, '', this.state.date, false);
      await getIncomingFaxesFilter(this.token, suggestion._id, '', this.state.date);
      await getFaxesSummaryByCompany(this.token, suggestion._id, this.state.date);
      await getFaxesFailureSummaryByCompany(this.token, suggestion._id, this.state.date);
    } else {
      if (
        user.role === 'superAdmin' ||
        user.role === 'supportEngineer' ||
        user.role === 'companyGroupAdmin' ||
        user.role === 'companyGroupManager'
      ) {
        this.setState({ selectedCompany: '', selectedUser: '' });
        await getOutgoingFaxes(this.token, {}, this.state.date, true);
        await getOutgoingFaxes(this.token, {}, this.state.date, false);
        await getIncomingFaxes(this.token, {}, this.state.date);
        this.props.getFaxesSummary(this.token, this.state.date);
        this.props.getFaxesFailureSummary(this.token, this.state.date);
      } else if (this.props.user.role === 'admin' || this.props.user.role === 'enterpriseAdmin') {
        this.setState({ selectedCompany: this.props.user.company._id });
        this.props.getCompanyNumbers(this.token, this.props.user.company._id, true, 'none');
        this.props.getOutgoingFaxesFilter(
          this.token,
          this.props.user.company._id,
          '',
          this.state.date,
          true,
        );
        await this.props.getOutgoingFaxesFilter(
          this.token,
          this.props.user.company._id,
          '',
          this.state.date,
          false,
        );
        await this.props.getIncomingFaxesFilter(
          this.token,
          this.props.user.company._id,
          '',
          this.state.date,
        );
        this.props.getFaxesSummaryByCompany(
          this.token,
          this.props.user.company._id,
          this.state.date,
        );
        this.props.getFaxesFailureSummaryByCompany(
          this.token,
          this.props.user.company._id,
          this.state.date,
        );
      }
    }
  };

  onUserTypeSelect = async ({ suggestion }) => {
    const {
      getOutgoingFaxesByUser,
      getIncomingFaxesByUser,
      getFaxesSummaryByUser,
      getFaxesSummary,
      getFaxesFailureSummary,
      getFaxesFailureSummaryByUser,
    } = this.props;
    this.setState({
      selectedNumber: '',
    });
    if (suggestion !== null) {
      this.setState({ selectedUser: suggestion._id });
      await getOutgoingFaxesByUser(this.token, suggestion._id, '', this.state.date, true);
      await getOutgoingFaxesByUser(this.token, suggestion._id, '', this.state.date, false);
      await getIncomingFaxesByUser(this.token, suggestion._id, '', this.state.date);
      await getFaxesSummaryByUser(this.token, suggestion._id, this.state.date);
      await getFaxesFailureSummaryByUser(this.token, suggestion._id, this.state.date);
    } else {
      this.setState({ selectedUser: '' });

      this.companyID = this.props.user.company._id;
      await this.props.getOutgoingFaxesFilter(
        this.token,
        this.state.selectedCompany,
        '',
        this.state.date,
        true,
      );
      await this.props.getOutgoingFaxesFilter(
        this.token,
        this.state.selectedCompany,
        '',
        this.state.date,
        false,
      );
      await this.props.getCompanyNumbers(this.token, this.state.selectedCompany, true, 'none');
      this.props.getIncomingFaxesFilter(
        this.token,
        this.state.selectedCompany,
        '',
        this.state.date,
      );
      this.props.getFaxesSummaryByCompany(this.token, this.state.selectedCompany, this.state.date);
      if (this.props.user.role !== 'admin') {
        getFaxesSummary(this.token);
        getFaxesFailureSummary(this.token);
      }
    }
  };

  handleDownloadSummary = () => {
    const { selectedCompany, selectedUser, selectedNumberType } = this.state;
    if (selectedCompany === '' && selectedUser === '') {
      if (global.activeStatTab === 'deliverySummary') {
        if (selectedNumberType !== '') {
          this.props.numberSummary(this.token, 'allByNumber', selectedNumberType, this.state.date);
        } else {
          this.props.downloadFaxSummary(this.token, this.state.date);
        }
      } else {
        if (selectedNumberType !== '') {
          this.props.numberSummary(
            this.token,
            'failedByNumber',
            selectedNumberType,
            this.state.date,
          );
        } else {
          this.props.downloadFaxSummary(this.token, this.state.date, 'failed');
        }
      }
    } else {
      if (selectedUser !== '') {
        if (global.activeStatTab === 'deliverySummary')
          this.props.downloadFaxSummaryByUser(
            this.token,
            selectedUser,
            this.state.date,
            'allByUser',
          );
        else
          this.props.downloadFaxSummaryByUser(
            this.token,
            selectedUser,
            this.state.date,
            'failedByUser',
          );
      } else if (selectedCompany !== '') {
        if (global.activeStatTab === 'deliverySummary')
          this.props.downloadFaxFailureSummaryByCompany(
            this.token,
            selectedCompany,
            this.state.date,
            'allByCompany',
          );
        else
          this.props.downloadFaxFailureSummaryByCompany(
            this.token,
            selectedCompany,
            this.state.date,
            'failedByCompany',
          );
      }
    }
  };

  handleSelectNumber = (e, type) => {
    this.setState({
      selectedNumberType: type,
      selectedNumber: e,
      selectedCompany: '',
      selectedUser: '',
    });
    this.props.faxNumberFilterSummary(this.token, e, type, this.state.date);
    this.props.faxNumberFilterFailureSummary(this.token, e, type, this.state.date);
    this.props.setActiveFaxTab('report');
  };

  selectSearchFilter = e => {
    this.setState({ selectedFilter: e, number: '' });
  };

  numberSearchFilter = e => {
    const { activeFaxTab, faxes } = this.props;
    const { defaultPage } = this.state;
    this.setState({ number: e });
    if (e === '' || e.length === 0) {
      this.setState({ number: '' }, () => {
        this.handleChangePagination(defaultPage);
      });
    } else {
      if (activeFaxTab === 'outgoing') {
        if (this.state.selectedFilter === 'By Destination Number') {
          this.props.outgoingfaxFilterByNumber(
            this.token,
            'dest',
            e,
            this.state.date,
            {
              page: defaultPage || 1,
              limit: this.limit || faxes.outgoingFaxes.limit,
            },
            false,
          );
        } else {
          this.props.outgoingfaxFilterByNumber(
            this.token,
            'cid',
            e,
            this.state.date,
            {
              page: defaultPage || 1,
              limit: this.limit || faxes.outgoingFaxes.limit,
            },
            false,
          );
        }
      } else if (activeFaxTab === 'relay') {
        if (this.state.selectedFilter === 'By Destination Number') {
          this.props.outgoingfaxFilterByNumber(
            this.token,
            'dest',
            e,
            this.state.date,
            {
              page: defaultPage || 1,
              limit: this.limit || faxes.outgoingFaxes.limit,
            },
            true,
          );
        } else {
          this.props.outgoingfaxFilterByNumber(
            this.token,
            'cid',
            e,
            this.state.date,
            {
              page: defaultPage || 1,
              limit: this.limit || faxes.outgoingFaxes.limit,
            },
            true,
          );
        }
      } else {
        if (this.state.selectedFilter === 'By Sender Number') {
          this.props.incomingfaxFilterByNumber(this.token, 'sender', e, this.state.date, {
            page: defaultPage || 1,
            limit: this.limit || faxes.outgoingFaxes.limit,
          });
        } else {
          this.props.incomingfaxFilterByNumber(this.token, 'receiver', e, this.state.date, {
            page: defaultPage || 1,
            limit: this.limit || faxes.outgoingFaxes.limit,
          });
        }
      }
    }
  };

  onRecoverOutgoing = async e => {
    var res = await this.props.onRecoverOutgoingFax(this.token, e);
    if (res) {
      this.handleChangePagination(this.state.defaultPage);
    }
  };

  onRecoverIncoming = async e => {
    var res = await this.props.onRecoverIncomingFax(this.token, e);
    if (res) {
      this.handleChangePagination(this.state.defaultPage);
    }
  };

  onCancelFax = async e => {
    const { onCancelFax } = this.props;
    const res = await onCancelFax(this.token, e);
    if (res) {
      this.handleChangePagination(this.state.defaultPage);
    }
  };
  onResendFax = async e => {
    const { onResendFax, activeFaxTab } = this.props;
    let relay = activeFaxTab === 'relay';
    const res = await onResendFax(this.token, e, relay);
    if (res) {
      this.handleChangePagination(this.state.defaultPage);
    }
  };

  handleSortFax = filter => {
    const { sort } = this.state;
    const updateSort = { ...sort };

    if (updateSort.name === filter) {
      updateSort.order = updateSort.order === 'asc' ? 'desc' : 'asc';
    } else {
      updateSort.name = filter;
      updateSort.order = 'asc';
    }
    this.setState({ sort: updateSort });
  };

  sortColumnByKey = array => {
    const { sort } = this.state;

    if (sort.name.indexOf('[') !== -1) {
      const sortNameArr = sort.name.replace(/[\[\]']+/g, ' ').split(' ');
      return orderBy(array, [el => el[sortNameArr[0]][sortNameArr[1]].toLowerCase()], [sort.order]);
    } else if (typeof array[0][sort.name] === 'string') {
      return orderBy(array, [el => el[sort.name].toLowerCase()], [sort.order]);
    } else {
      return orderBy(array, [el => el[sort.name]], [sort.order]);
    }
  };

  render() {
    const { date, selectedFilter, sort } = this.state;
    const { user, faxes, emails, deleteMode } = this.props;
    if (!user || !user._id) {
      return <Redirect to="/login" />;
    }
    const renderList = sort.name.length
      ? this.sortColumnByKey(faxes.outgoingFaxes.docs)
      : faxes.outgoingFaxes.docs;

    const renderRelayList = sort.name.length
      ? this.sortColumnByKey(faxes.relay.docs)
      : faxes.relay.docs;

    const renderIncomingList = sort.name.length
      ? this.sortColumnByKey(faxes.incomingFaxes.docs)
      : faxes.incomingFaxes.docs;

    return (
      <div>
        <div className="filter-section">
          <Row>
            {/* <Col md={3} sm={12}>
              <Breadcrumbs />
            </Col> */}
            <Col md={12} sm={12}>
              <Row className="align-items-center justify-content-end">
                {/* <Col md="2" className="select-limit">
                  <SetLimitEntries
                    value={
                      this.props.activeFaxTab === 'outgoing'
                        ? faxes.outgoingFaxes.limit
                        : faxes.incomingFaxes.limit
                    }
                    onChange={this.handleSetLimit}
                  />
                </Col> */}

                {(this.props.user.role === 'superAdmin' ||
                  this.props.user.role === 'supportEngineer' ||
                  this.props.user.role === 'companyGroupAdmin' ||
                  this.props.user.role === 'companyGroupManager') && (
                    <Col md={2}>
                      <Button
                        color="primary"
                        className="float-right"
                        onClick={this.props.showSendFax}
                        disabled={this.props.user?.readOnly}
                      >
                        New Fax
                      </Button>
                    </Col>
                  )}

                <Col md={4} style={{ display: 'flex' }}>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend" className="filter-icon-div">
                      <img src={filterIcon} className="filter-icon" alt="..." />
                    </InputGroupAddon>

                    <Input
                      type="select"
                      className="filter-append-dropdown"
                      onChange={e => this.selectSearchFilter(e.currentTarget.value)}
                    >
                      {this.props.activeFaxTab === 'outgoing' || this.props.activeFaxTab === 'relay'
                        ? this.outgoingFaxOptions?.map(el => (
                          <option key={el} value={el}>
                            {el}
                          </option>
                        ))
                        : this.incomingFaxOptions?.map(el => (
                          <option key={el} value={el}>
                            {el}
                          </option>
                        ))}
                    </Input>
                  </InputGroup>
                  {this.props.user.role === 'superAdmin' ||
                    this.props.user.role === 'supportEngineer' ||
                    this.props.user.role === 'companyGroupAdmin' ||
                    this.props.user.role === 'companyGroupManager' ? (
                    // <Col md={{ size: 2 }}>
                    selectedFilter === 'By Company' ? (
                      this.props.companies?.docs && (
                        <CompanyAutocomplete
                          searchTerm={this.props.companyFilter?.value}
                          placeholder="Filter Company..."
                          companies={this.props.companies?.docs}
                          onChange={this.companySearchFilter}
                        />
                      )
                    ) : (
                      <Input
                        type="text"
                        value={this.state.number}
                        placeholder={`Filter ${this.state.selectedFilter}`}
                        onChange={e => this.numberSearchFilter(e.target.value)}
                      />
                    )
                  ) : (
                    // </Col>
                    // <Col md={{ size: 2 }}>
                    <Input
                      type="text"
                      value={this.state.number}
                      placeholder={`Filter ${this.state.selectedFilter}`}
                      onChange={e => this.numberSearchFilter(e.target.value)}
                    />
                    // </Col>
                  )}
                </Col>

                {/* {this.props.user.role === 'superAdmin' ||
                this.props.user.role === 'companyGroupAdmin' ||
                this.props.user.role === 'companyGroupManager' ? (
                  <Col md={{ size: 2 }}>
                    {selectedFilter === 'By Company' ? (
                      this.props.companies.docs && (
                        <CompanyAutocomplete
                          searchTerm={this.props.companyFilter.value}
                          placeholder="Filter Company..."
                          companies={this.props.companies.docs}
                          onChange={this.companySearchFilter}
                        />
                      )
                    ) : (
                      <Input
                        type="text"
                        value={this.state.number}
                        placeholder={`Filter ${this.state.selectedFilter}`}
                        onChange={e => this.numberSearchFilter(e.target.value)}
                      />
                    )}
                  </Col>
                ) : (
                  <Col md={{ size: 2 }}>
                    <Input
                      type="text"
                      value={this.state.number}
                      placeholder={`Filter ${this.state.selectedFilter}`}
                      onChange={e => this.numberSearchFilter(e.target.value)}
                    />
                  </Col>
                )} */}

                {(this.props.user.role === 'superAdmin' ||
                  this.props.user.role === 'supportEngineer' ||
                  this.props.user.role === 'companyGroupAdmin' ||
                  this.props.user.role === 'companyGroupManager') &&
                  (emails !== null ? (
                    <Col md={2} style={{ display: 'flex' }}>
                      <InputGroupAddon addonType="prepend" className="filter-icon-div">
                        <img src={filterIcon} className="filter-icon" alt="..." />
                      </InputGroupAddon>
                      <CompanyAutocomplete
                        searchTerm={emails?.email}
                        placeholder="User Filter..."
                        companies={emails?.emails || []}
                        onChange={this.onUserTypeSelect}
                        userAutocomplete={true}
                      />
                    </Col>
                  ) : null)}

                {(this.props.user.role === 'admin' || this.props.user.role === 'enterpriseAdmin') &&
                  (emails !== null ? (
                    <Col md={3}>
                      <CompanyAutocomplete
                        searchTerm={emails.email}
                        placeholder="User Filter..."
                        companies={emails.emails || []}
                        onChange={this.onUserTypeSelect}
                        userAutocomplete={true}
                      />
                    </Col>
                  ) : null)}

                <DateRangePicker
                  autoUpdateInput
                  startDate={date[1] || startOfDay(new Date())}
                  endDate={date[0] || endOfDay(new Date())}
                  onApply={this.onApply}
                  showCustomRangeLabel
                  alwaysShowCalendars
                  ranges={this.ranges}
                  opens="left"
                  onHide={this.handeleClick}
                  onShow={this.handeleClick}
                >
                  <div className="input-group" style={{ alignItems: 'center' }}>
                    <span className="input-group-btn">
                      <Button
                        className="default date-range-toggle"
                        style={{
                          background: '#DDE6FA',
                          border: 'none',
                          color: '#FF2437',
                          width: '4rem',
                        }}
                      >
                        <img style={{ width: '50%' }} src={Calendar} alt="..."></img>
                      </Button>
                    </span>
                    <div className="view-data-input">
                      {format(date[1], 'MM/dd/yyyy')} - {format(date[0], 'MM/dd/yyyy')}
                    </div>
                  </div>
                </DateRangePicker>
              </Row>
            </Col>
          </Row>
        </div>

        <Container fluid style={{ margin: 0 }}>
          <div className="viewContainer" style={{ marginTop: '20px' }}>
            <ButtonGroup className="tab-group">
              <Button
                className={classnames({ active: this.props.activeFaxTab === 'outgoing' })}
                onClick={() => {
                  this.setState({ selectedFilter: this.outgoingFaxOptions[0] });
                  this.props.setActiveFaxTab('outgoing');
                }}
              >
                Outgoing Faxes ({faxes?.outgoingFaxes?.docs ? faxes?.outgoingFaxes?.totalDocs : '0'})
              </Button>

              <Button
                className={classnames({ active: this.props.activeFaxTab === 'incoming' })}
                onClick={() => {
                  this.setState({ selectedFilter: this.incomingFaxOptions[0] });
                  this.props.setActiveFaxTab('incoming');
                }}
              >
                Incoming Faxes ({faxes?.incomingFaxes?.docs ? faxes?.incomingFaxes?.totalDocs : '0'})
              </Button>

              <Button
                className={classnames({ active: this.props.activeFaxTab === 'relay' })}
                onClick={() => {
                  this.setState({ selectedFilter: this.incomingFaxOptions[0] });
                  this.props.setActiveFaxTab('relay');
                }}
              >
                Relay ({faxes?.relay.docs ? faxes?.relay.totalDocs : '0'})
              </Button>

              <Button
                className={classnames({
                  active: this.props.activeFaxTab === 'report',
                })}
                onClick={() => {
                  this.setState({ selectedFilter: this.outgoingFaxOptions[0] });
                  this.props.setActiveFaxTab('report');
                }}
              >
                Stats ({faxes?.faxesSummary.length + faxes?.faxesFailureSummary.length})
              </Button>
            </ButtonGroup>

            {/* <Row>
          <Col md="12">
            {this.props.activeFaxTab === 'report' ? (
              <>
                {this.state.selectedNumber !== '' ? (
                  <p className="number-filter">
                    <span>Selected Number:</span> {this.state.selectedNumber}
                  </p>
                ) : null}
                <Button className="default CDR-btn" onClick={this.handleDownloadSummary}>
                  <FontAwesomeIcon icon="download" className="analytic-filter-icon" />
                </Button>
              </>
            ) : null}
          </Col>
        </Row> */}
            <Row>
              <Col md="12">
                <TabContent activeTab={this.props.activeFaxTab}>
                  <TabPane tabId="outgoing">
                    <Row>
                      <Col md={12}>
                        {faxes?.outgoingFaxes?.docs && (
                          <FaxList
                            onRecover={this.onRecoverOutgoing}
                            deleteMode={deleteMode}
                            faxes={renderList}
                            onSelectNumber={this.handleSelectNumber}
                            onDelete={this.props.showDeleteFax}
                            onCancel={this.onCancelFax}
                            onResend={this.onResendFax}
                            onDownload={this.onDownloadOutgoingFax}
                            sortValue={sort}
                            onSort={this.handleSortFax}
                          />
                        )}
                      </Col>
                    </Row>

                    {faxes?.outgoingFaxes?.totalPages > 1 && (
                      <Row className="justify-content-md-center">
                        <SetLimitEntries
                          value={
                            this.props.activeFaxTab === 'outgoing'
                              ? faxes?.outgoingFaxes?.limit
                              : faxes?.incomingFaxes?.limit
                          }
                          onChange={this.handleSetLimit}
                        />

                        <Pagination
                          locale={ENG_LOCALE}
                          className="pagination-container"
                          onChange={this.handleChangePagination}
                          current={faxes?.outgoingFaxes?.page}
                          total={faxes?.outgoingFaxes?.totalDocs}
                          pageSize={faxes?.outgoingFaxes?.limit}
                          showLessItems
                          showTotal={(total, range) =>
                            `${range[0]} - ${range[1]} of ${total} items`
                          }
                        />
                      </Row>
                    )}

                    {/* <Row>
                      <Col md={12}>
                        {faxes?.outgoingFaxes?.totalPages > 1 && (
                          <Pagination
                            className="pagination-container"
                            onChange={this.handleChangePagination}
                            current={faxes?.outgoingFaxes?.page}
                            total={faxes?.outgoingFaxes?.totalDocs}
                            pageSize={faxes?.outgoingFaxes?.limit}
                            showLessItems
                          />
                        )}
                      </Col>
                    </Row> */}
                  </TabPane>

                  <TabPane tabId="incoming">
                    <Row>
                      <Col md={12}>
                        {faxes?.incomingFaxes?.docs && (
                          <IncomingFaxList
                            onRecover={this.onRecoverIncoming}
                            deleteMode={deleteMode}
                            incomingFaxes
                            faxes={renderIncomingList}
                            onDelete={this.props.showDeleteFax}
                            onDownload={this.onDownloadIncomingFax}
                            sortValue={sort}
                            onSort={this.handleSortFax}
                          />
                        )}
                      </Col>
                    </Row>

                    {faxes?.incomingFaxes?.totalPages > 1 && (
                      <Row className="justify-content-md-center">
                        <SetLimitEntries
                          value={
                            this.props.activeFaxTab === 'outgoing'
                              ? faxes?.outgoingFaxes?.limit
                              : faxes?.incomingFaxes?.limit
                          }
                          onChange={this.handleSetLimit}
                        />
                        <Pagination
                          locale={ENG_LOCALE}
                          className="pagination-container"
                          onChange={this.handleChangePagination}
                          current={faxes?.incomingFaxes?.page}
                          total={faxes?.incomingFaxes?.totalDocs}
                          pageSize={faxes?.incomingFaxes?.limit}
                          showLessItems
                          showTotal={(total, range) =>
                            `${range[0]} - ${range[1]} of ${total} items`
                          }
                        />
                      </Row>
                    )}

                    {/* <Row>
                      <Col md={12}>
                        {faxes?.incomingFaxes?.totalPages > 1 && (
                          <Pagination
                            className="pagination-container"
                            onChange={this.handleChangePagination}
                            current={faxes?.incomingFaxes?.page}
                            total={faxes?.incomingFaxes?.totalDocs}
                            pageSize={faxes?.incomingFaxes?.limit}
                            showLessItems
                          />
                        )}
                      </Col>
                    </Row> */}
                  </TabPane>
                  <TabPane tabId="relay">
                    <Row>
                      <Col md={12}>
                        {faxes?.relay.docs && (
                          <FaxList
                            onRecover={this.onRecoverOutgoing}
                            deleteMode={deleteMode}
                            faxes={renderRelayList}
                            onSelectNumber={this.handleSelectNumber}
                            onDelete={this.props.showDeleteFax}
                            onCancel={this.onCancelFax}
                            onResend={this.onResendFax}
                            onDownload={this.onDownloadOutgoingFax}
                            sortValue={sort}
                            onSort={this.handleSortFax}
                          />
                        )}
                      </Col>
                    </Row>

                    {faxes?.relay.totalPages > 1 && (
                      <Row className="justify-content-md-center">
                        <SetLimitEntries
                          value={
                            this.props.activeFaxTab === 'relay'
                              ? faxes?.relay.limit
                              : faxes?.incomingFaxes?.limit
                          }
                          onChange={this.handleSetLimit}
                        />
                        <Pagination
                          locale={ENG_LOCALE}
                          className="pagination-container"
                          onChange={this.handleChangePagination}
                          current={faxes?.relay.page}
                          total={faxes?.relay.totalDocs}
                          pageSize={faxes?.relay.limit}
                          showLessItems
                          showTotal={(total, range) =>
                            `${range[0]} - ${range[1]} of ${total} items`
                          }
                        />
                      </Row>
                    )}

                    {/* <Row>
                      <Col md={12}>
                        {faxes?.outgoingFaxes?.totalPages > 1 && (
                          <Pagination
                            className="pagination-container"
                            onChange={this.handleChangePagination}
                            current={faxes?.outgoingFaxes?.page}
                            total={faxes?.outgoingFaxes?.totalDocs}
                            pageSize={faxes?.outgoingFaxes?.limit}
                            showLessItems
                          />
                        )}
                      </Col>
                    </Row> */}
                  </TabPane>

                  <TabPane tabId="report">
                    <Row>
                      <Col md={12}>
                        <FaxesReportTab
                          faxes={faxes?.faxesSummary}
                          failure={faxes?.faxesFailureSummary}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        {/* {faxes?.outgoingFaxes?.totalPages > 1 &&
                      <Pagination
                        className="pagination-container"
                        onChange={this.handleChangePagination}
                        current={faxes?.outgoingFaxes?.page}
                        total={faxes?.outgoingFaxes?.totalDocs}
                        pageSize={faxes?.outgoingFaxes?.limit}
                        showLessItems
                      />
                    } */}
                      </Col>
                    </Row>
                  </TabPane>
                </TabContent>
              </Col>
            </Row>
          </div>
          <DeleteFaxModal
            isOpen={this.props.deleteFaxShow}
            onCancel={this.props.deleteFaxCancel}
            onConfirm={this.onDelete}
          />
          <SendFaxModal
            isOpen={this.props.sendFaxShow}
            onCancel={this.props.sendFaxCancel}
            onConfirm={this.onSendFax}
            onSendFax={this.onSendFax}
          />
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  faxes: state.AppState.faxes,
  user: state.AppState.user,
  companies: state.AppState.companies,
  companyFilter: state.UIState.epikBoxes.companyFilter,
  deleteFaxShow: state.UIState.faxes.deleteFaxShow,
  deleteFaxID: state.UIState.faxes.deleteFaxID,
  sendFaxShow: state.UIState.faxes.sendFaxShow,
  activeFaxTab: state.UIState.faxes.activeFaxTab,
  emails: state.UIState.numbers.filterNumbersByCompany.number,
  numbers: state.AppState.numbers,
  number: state.UIState.numbers.addNumber,
  deleteMode: state.AppState.deleteMode,
});

const mapDispatchToProps = dispatch => ({
  onRecoverIncomingFax: (token, id) => dispatch(FaxActions.onRecoverIncomingFax(token, id)),
  onRecoverOutgoingFax: (token, id) => dispatch(FaxActions.onRecoverOutgoingFax(token, id)),
  getCompanies: (token, pagination, disablePaginate) =>
    dispatch(CompanyActions.getCompanies(token, pagination, disablePaginate)),
  getFaxes: token => dispatch(FaxActions.getFaxes(token)),
  deleteOutgoingFax: (token, id) => dispatch(FaxActions.deleteOutgoingFax(token, id)),
  deleteIncomingFax: (token, id) => dispatch(FaxActions.deleteIncomingFax(token, id)),
  showDeleteFax: id => dispatch(FaxActions.deleteFaxShow(id)),
  showSendFax: () => dispatch(FaxActions.sendFaxShow()),
  sendFaxCancel: () => dispatch(FaxActions.sendFaxCancel()),
  sendFax: fax => dispatch(FaxActions.sendFax(fax)),
  deleteFaxCancel: () => dispatch(FaxActions.deleteFaxCancel()),
  downloadIncomingFax: (token, id, userID) =>
    dispatch(FaxActions.downloadIncomingFax(token, id, userID)),
  downloadOutgoingFax: (token, id, userID) =>
    dispatch(FaxActions.downloadOutgoingFax(token, id, userID)),
  setActiveFaxTab: tabId => dispatch(FaxActions.setActiveFaxTab(tabId)),
  getIncomingFaxes: (token, paginateOptions, dateFilter) =>
    dispatch(FaxActions.getIncomingFaxes(token, paginateOptions, dateFilter)),
  getOutgoingFaxes: (token, paginateOptions, dateFilter, relay) =>
    dispatch(FaxActions.getOutgoingFaxes(token, paginateOptions, dateFilter, relay)),
  getOutgoingFaxesFilter: (token, companyId, paginateOptions, date, relay) =>
    dispatch(FaxActions.getOutgoingFaxesFilter(token, companyId, paginateOptions, date, relay)),
  getIncomingFaxesFilter: (token, companyId, paginateOptions, date) =>
    dispatch(FaxActions.getIncomingFaxesFilter(token, companyId, paginateOptions, date)),
  getFaxesSummary: (token, date) => dispatch(FaxActions.getFaxesSummary(token, date)),
  getFaxesFailureSummary: (token, date) => dispatch(FaxActions.getFaxesFailureSummary(token, date)),
  getFaxesSummaryByUser: (token, id, date) =>
    dispatch(FaxActions.getFaxesSummaryByUser(token, id, date)),
  getFaxesSummaryByCompany: (token, id, date) =>
    dispatch(FaxActions.getFaxesSummaryByCompany(token, id, date)),
  getFaxesFailureSummaryByCompany: (token, id, date) =>
    dispatch(FaxActions.getFaxesFailureSummaryByCompany(token, id, date)),
  getFaxesFailureSummaryByUser: (token, id, date) =>
    dispatch(FaxActions.getFaxesFailureSummaryByUser(token, id, date)),
  getCompanyNumbers: (token, id, uid, type) => dispatch(getCompanyNumbers(token, id, uid, type)),
  getOutgoingFaxesByUser: (token, userID, paginateOptions, date, relay) =>
    dispatch(FaxActions.getOutgoingFaxesByUser(token, userID, paginateOptions, date, relay)),
  getIncomingFaxesByUser: (token, userID, paginateOptions, date) =>
    dispatch(FaxActions.getIncomingFaxesByUser(token, userID, paginateOptions, date)),
  numberSummary: (token, reportOf, type, date) =>
    dispatch(FaxActions.numberSummary(token, reportOf, type, date)),
  downloadFaxSummary: (token, date, type) =>
    dispatch(FaxActions.downloadFaxSummary(token, date, type)),
  downloadFaxSummaryByUser: (token, userID, date, type) =>
    dispatch(FaxActions.downloadFaxSummaryByUser(token, userID, date, type)),
  downloadFaxFailureSummaryByCompany: (token, userID, date, type) =>
    dispatch(FaxActions.downloadFaxFailureSummaryByCompany(token, userID, date, type)),
  faxNumberFilterSummary: (token, number, type, date) =>
    dispatch(FaxActions.faxNumberFilterSummary(token, number, type, date)),
  faxNumberFilterFailureSummary: (token, number, type, date) =>
    dispatch(FaxActions.faxNumberFilterFailureSummary(token, number, type, date)),
  outgoingfaxFilterByNumber: (token, type, value, date, paginateOptions, relay) =>
    dispatch(
      FaxActions.outgoingfaxFilterByNumber(token, type, value, date, paginateOptions, relay),
    ),
  incomingfaxFilterByNumber: (token, type, value, date, paginateOptions) =>
    dispatch(FaxActions.incomingfaxFilterByNumber(token, type, value, date, paginateOptions)),
  onCancelFax: (token, id) => dispatch(FaxActions.onCancelFax(token, id)),
  onResendFax: (token, id, relay) => dispatch(FaxActions.onResendFax(token, id, relay)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithUserData(Fax));
